import React, { FC, ReactElement } from 'react';
import {
    StyledHeaderContainer,
    StyledHeader,
    StyledMenuContainer,
    StyledDesktopMenuContainer,
    StyledMobileMenuContainer,
} from './styled';
import { KscLogo } from './KscLogo';

interface HeaderProps {
    desktopMenu: ReactElement;
    mobileMenu?: ReactElement;
    logo: ReactElement;
    stickyOnMobile?: boolean;
}

export const Header: FC<HeaderProps> = ({ desktopMenu, mobileMenu, logo, stickyOnMobile }) => (
    <StyledHeader stickyOnMobile={stickyOnMobile}>
        <StyledHeaderContainer data-testid="header">
            <KscLogo />
            <StyledMenuContainer>
                <StyledDesktopMenuContainer>{desktopMenu}</StyledDesktopMenuContainer>
                <StyledMobileMenuContainer>{mobileMenu}</StyledMobileMenuContainer>
            </StyledMenuContainer>
        </StyledHeaderContainer>
    </StyledHeader>
);
